import { Action, Reducer } from 'redux';
import { UserTypeState, UserTypeTypes, UserTypeActionTypes } from './userTypeTypes';

export const INITIAL_STATE: UserTypeState = {
  userType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },

  userTypePublic: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const userTypeReducer: Reducer<UserTypeState> = (
  state: UserTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as UserTypeActionTypes;
  switch (actionTypes.type) {
    case UserTypeTypes.GET_USER_TYPE:
      return {
        ...state,
        userType: { ...state.userType, isLoading: true }
      };
    case UserTypeTypes.SAVE_USER_TYPE:
      return {
        ...state,
        userType: {
          ...state.userType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };

      case UserTypeTypes.GET_USER_TYPE_PUBLIC:
      return {
        ...state,
        userTypePublic: { ...state.userTypePublic, isLoading: true }
      };
    case UserTypeTypes.SAVE_USER_TYPE_PUBLIC:
      return {
        ...state,
        userTypePublic: {
          ...state.userTypePublic,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case UserTypeTypes.RESET_REDUCER_USER_TYPE:
      return {
        ...state,
        userType: INITIAL_STATE.userType
      };
    default:
      return state;
  }
};

export default userTypeReducer;
